module.exports = __webpack_public_path__ + "img/banner-data.c7fb6a32.png";